//@ ts-ignore
import vue from 'vue/dist/vue.js'
export default vue
